export const PAGER = {
  COMPLETE: 'complete',
  FAIL: 'fail'
};

export const CHANGE_BOARD_SEARCH_OPTION = 'changeBoardSearchOption';
